import { CrudService } from './CrudService';
import { ActivityQueryParams } from '../params/ActivityQueryParams';
import { ActivityDto } from '../models/activity/ActivityDto';
import { ActivityDtoUpdate } from '../models/activity/ActivityDtoUpdate';
import { resources } from '../resources';

export class ActivityService extends CrudService<ActivityDto, ActivityQueryParams, ActivityDtoUpdate> {
  constructor() {
    super({
      query: resources.queryActivities,
      get: resources.getActivity,
      create: resources.createActivity,
      update: resources.updateActivity,
      idKey: 'activityId',
    });
  }
}
